import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type LockIconProps = {
  fillColor?: string;
} & IconProps;

const LockIcon: FC<LockIconProps> = ({ className, fillColor, iconColor = '#344054', ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 12 12"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 7.4C2 6.55992 2 6.13988 2.16349 5.81901C2.3073 5.53677 2.53677 5.3073 2.81901 5.16349C3.13988 5 3.55992 5 4.4 5H7.6C8.44008 5 8.86012 5 9.18099 5.16349C9.46323 5.3073 9.6927 5.53677 9.83651 5.81901C10 6.13988 10 6.55992 10 7.4V8.1C10 8.94008 10 9.36012 9.83651 9.68099C9.6927 9.96323 9.46323 10.1927 9.18099 10.3365C8.86012 10.5 8.44008 10.5 7.6 10.5H4.4C3.55992 10.5 3.13988 10.5 2.81901 10.3365C2.53677 10.1927 2.3073 9.96323 2.16349 9.68099C2 9.36012 2 8.94008 2 8.1V7.4Z"
      fill={fillColor ?? 'none'}
    />
    <path
      d="M8.5 5V4C8.5 2.61929 7.38071 1.5 6 1.5C4.61929 1.5 3.5 2.61929 3.5 4V5M6 7.25V8.25M4.4 10.5H7.6C8.44008 10.5 8.86012 10.5 9.18099 10.3365C9.46323 10.1927 9.6927 9.96323 9.83651 9.68099C10 9.36012 10 8.94008 10 8.1V7.4C10 6.55992 10 6.13988 9.83651 5.81901C9.6927 5.53677 9.46323 5.3073 9.18099 5.16349C8.86012 5 8.44008 5 7.6 5H4.4C3.55992 5 3.13988 5 2.81901 5.16349C2.53677 5.3073 2.3073 5.53677 2.16349 5.81901C2 6.13988 2 6.55992 2 7.4V8.1C2 8.94008 2 9.36012 2.16349 9.68099C2.3073 9.96323 2.53677 10.1927 2.81901 10.3365C3.13988 10.5 3.55992 10.5 4.4 10.5Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

LockIcon.displayName = 'LockIcon';

export default LockIcon;
